import React from 'react';
import { useSelector } from 'react-redux';

import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';

import classes from './Loading.module.css';

const Loading = ({ open = true, title, subtitle }) => {
    //const is_loading = useSelector(state => state.navigation.is_loading); // redux

    return (
      <div>
        <Backdrop className={classes.backdrop} open={open}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, px: 3 }}>
            <CircularProgress color="inherit" />

            {(title || subtitle) && (
              <Box sx={{ textAlign: 'center', maxWidth: 420 }}>
                {title && (
                  <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700 }}>
                    {title}
                  </Typography>
                )}
                {subtitle && (
                  <Typography variant="body2" sx={{ mt: 1, color: 'rgba(255,255,255,0.9)' }}>
                    {subtitle}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </Backdrop>
      </div>
    );
}

export default Loading;